'use client';

import { useState, useCallback, RefObject } from 'react';

interface DropdownPosition {
  position: 'fixed';
  left: string;
  minWidth: string;
  top: string;
  transform: string;
  zIndex: number;
}

export const useDropdownPosition = (
  buttonRef: RefObject<HTMLElement>,
  dropdownHeight = 300
) => {
  const [dropdownPosition, setDropdownPosition] = useState<'top' | 'bottom'>(
    'bottom'
  );
  const [dropdownStyle, setDropdownStyle] = useState<DropdownPosition | Record<string, never>>({});

  const calculatePosition = useCallback(() => {
    if (!buttonRef.current) return;

    const buttonRect = buttonRef.current.getBoundingClientRect();
    const spaceBelow = window.innerHeight - buttonRect.bottom;
    const spaceAbove = buttonRect.top;

    const position =
      spaceBelow < dropdownHeight && spaceAbove > dropdownHeight
        ? 'top'
        : 'bottom';

    setDropdownPosition(position);
    setDropdownStyle({
      position: 'fixed',
      left: `${buttonRect.left}px`,
      minWidth: `${buttonRect.width}px`,
      top:
        position === 'top'
          ? `${buttonRect.top - 4}px`
          : `${buttonRect.bottom + 4}px`,
      transform: position === 'top' ? 'translateY(-100%)' : 'none',
      zIndex: 50,
    });
  }, [buttonRef, dropdownHeight]);

  return {
    dropdownPosition,
    dropdownStyle,
    calculatePosition,
  };
};
